import { IMetadata } from '../../interfaces/common';
import { getApiCached } from '../../utils/api';

export interface IConsultationOutcomeGroup {
  consultationOutcomeGroupId: number;
  consultationOutcomeGroupDescription: string;
}

// api/Lookup/ConsultationOutcomes
export interface IConsultationSubOutcome extends IMetadata {
  consultationSubOutcomeId: number;
  consultationSubOutcomeDescription: string;
  consultationSubOutcomeDescriptionShort: string;
  consultationOutcomeId: number;
  displayOrder: number;
}
export interface IConsultationOutcome extends IMetadata {
  consultationOutcomeId: number;
  consultationOutcomeDescription: string;
  consultationOutcomeDescriptionShort: string;
  consultationOutcomeGroup: IConsultationOutcomeGroup;
  displayOrder: number;
  subOutcomes: IConsultationSubOutcome[];
  selectedSubOutcome?: IConsultationSubOutcome;
}

export const getConsultationOutcomes = () =>
  getApiCached<IConsultationOutcome[]>('lookup/consultationoutcomes');
